import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid';
import { useGeneratePhotoGrid } from '../hooks/useGeneratePhotoGrid';
import RelatedPhotosGridTile from './RelatedPhotosGridTile';

import styles from './RelatedPhotosGrid.scss';

import { type RelatedPhotosGrid_photos$key } from './__generated__/RelatedPhotosGrid_photos.graphql';

type Props = {
    photoId: string;
    isMobile: boolean;
    photos: RelatedPhotosGrid_photos$key | null | undefined;
};

const COLUMNS_MAX = 12;

const COLUMNS_PER_PAGE = {
    DESKTOP: 4,
    MOBILE: 2,
};

const RelatedPhotosGrid: FC<Props> = props => {
    const { isMobile, photoId, photos: photosRef } = props;

    const photos = useFragment(
        graphql`
            fragment RelatedPhotosGrid_photos on PhotosSearchBrowseQueryConnection {
                edges {
                    node {
                        serviceId
                        ...RelatedPhotosGridTile_photo
                    }
                }
            }
        `,
        photosRef
    );

    const columnsPerPage = isMobile ? COLUMNS_PER_PAGE.MOBILE : COLUMNS_PER_PAGE.DESKTOP;

    const { photoGrid } = useGeneratePhotoGrid({
        columnsPerPage,
        photoEdges: photos?.edges,
        mainPhotoId: photoId,
    });

    const mobileCol = COLUMNS_MAX / columnsPerPage;

    return (
        <div className={styles.wrapper}>
            <GridRow>
                {photoGrid.map((column, columnIndex) => (
                    <GridCol mobile={mobileCol} key={`photo-column-${columnIndex}`}>
                        {column.map((photo, index) => {
                            const key = photo.serviceId || `${columnIndex}-${index}`;
                            return (
                                <RelatedPhotosGridTile
                                    key={key}
                                    photo={photo}
                                    isMobile={isMobile}
                                />
                            );
                        })}
                    </GridCol>
                ))}
            </GridRow>
        </div>
    );
};

export default RelatedPhotosGrid;
